module.exports = "<navbar></navbar>\n\n<main>\n  <div id=\"app\" class=\"container-fluid\" ng-class=\"app.openedComponent\">\n    <ui-view></ui-view>\n  </div>\n</main>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/app.html
 ** module id = 2
 ** module chunks = 0
 **/